module.exports = __webpack_public_path__ + "static/img/calendar-check.6a7112dc.svg";